export default "__VITE_ASSET__Cal9qI_M__"